// extracted by mini-css-extract-plugin
export default {"headerContainer":"NotQualified_headerContainer__9xuzz","infoIcon":"NotQualified_infoIcon__7wccw","title":"NotQualified_title__vlyC2"};